import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles()((theme) => ({
	adlinkAnchor: {
		textDecoration: 'none',
	},
	adlink: {
		display: 'flex',
		position: 'relative',
		alignItems: 'center',
		justifyContent: 'space-between',
		height: theme.list.item.height.large,
	},
	adlinkContent: {
		padding: `${theme.spacing.small} ${theme.spacing.small} ${theme.spacing.small} 0`,
		overflow: 'hidden',
		width: '100%',
		display: 'grid',
		gridTemplateColumns: '1fr 35%',
		alignItems: 'center',
		justifyContent: 'space-between',
		gridColumnGap: theme.spacing.small,
	},
	adlinkName: {
		color: 'inherit',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		gridColumn: '1 / 2',
	},
	adlinkImage: {
		maxHeight: theme.spacing.medium,
		gridColumn: '2 / 3',
		marginLeft: 'auto',
		maxWidth: '100%',
	},
	adlinkButton: {
		color: 'inherit',
		backgroundColor: 'inherit',
	},
}));
